import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';

export class SetPasswordController {
   static $inject = ['$state', '$stateParams', 'session', 'toast'];

   constructor(
      private $state:uir.StateService,
      $stateParams:uir.StateParams,
      private session,
      private toast
   ) {
      // when URL has actual token, input is disabled in view using this.token
      if ($stateParams.token != 'verify') {
         this.token = $stateParams.token;
         this.verify = { token: this.token };
      } else {
         this.verify = { token: null }
      }
   }

   token:string;
   verify:{token:string, password?:string, confirmPassword?:string};
   validating = false;

   validate() {
      this.validating = true;
      this.session.forgotVerify(this.verify.token, this.verify.password, this.verify.confirmPassword).then(() => {
         this.toast.success()
            .title('Success')
            .message('Your password has been reset, please sign in to continue')
            .send();
         this.$state.go('login');
      }).catch(err => {
         if (err && err.data.errors) {
            this.handleValidationErrors(err.data.errors);
         } else {
            this.toast.error()
               .formErrors(err)
               .message('Something went wrong! Please try again.')
               .send();
         }
      }).finally(() => this.validating = false);
   }

   private handleValidationErrors(errors: any) {
      const errorMessage = Object.keys(errors)
         .map(key => errors[key][0])
         .find(errorMessage => errorMessage);

      if (errorMessage) {
         this.toast.error()
            .message(errorMessage)
            .send();
      }
   }
}

ng.module('e360').component('setPassword', {
   controller: SetPasswordController,
   templateUrl: require('./set-password.html')
});
